import React from 'react';
import Rehype2react from 'rehype-react';
import clsx from 'clsx';

import {
  Box,
  Divider,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Link,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  markdown: {
    '& .MuiTypography-body1 + .MuiTypography-body1:not(li)': {
      margin: theme.spacing(2, 0),
    },
    '& .MuiTypography-body2 + .MuiTypography-body2:not(li)': {
      margin: theme.spacing(1, 0),
    },
    '& [class*="MuiTypography-h"]:not(:first-child)': {
      marginTop: theme.spacing(4),
    },
  },
}));

const HtmlAstRender = ({
  hast,
  body = 'body1',
  textColor = 'initial',
  className,
  ...rest
}) => {
  const classes = useStyles();

  const defaultComponent = content => (
    <Typography variant={body} color={textColor}>
      {content}
    </Typography>
  );

  const renderAst = new Rehype2react({
    createElement: React.createElement,
    Fragment: React.Fragment,
    components: {
      h1: props => <Typography variant="h1" color={textColor} {...props} />,
      h2: props => <Typography variant="h2" color={textColor} {...props} />,
      h3: props => <Typography variant="h3" color={textColor} {...props} />,
      h4: props => <Typography variant="h4" color={textColor} {...props} />,
      h5: props => <Typography variant="h5" color={textColor} {...props} />,
      h6: props => <Typography variant="h6" color={textColor} {...props} />,
      hr: props => <Divider {...props} />,
      p: props => <Typography variant={body} color={textColor} {...props} />,
      li: props => <Typography variant={body} color={textColor} component="li" {...props} />,
      a: props => <Link {...props} />,
      table: props => <Table {...props} />,
      thead: props => <TableHead {...props} />,
      tbody: props => <TableBody {...props} />,
      tr: props => <TableRow {...props} />,
      td: props => <TableCell {...props} />,
      th: props => <TableCell component="th" {...props} />,
    },
  }).Compiler;

  const isOnlyText = hast.children.length === 1 && hast.children[0].type === 'text';

  const content = isOnlyText
    ? defaultComponent(hast.children[0].value)
    : renderAst(hast);

  return (
    <Box className={clsx(classes.markdown, className)} {...rest}>{content}</Box>
  );
};

export default HtmlAstRender;
